import React from "react";

function Footer() {
  return (
    <footer>
      <div id="footer-content">
        Made with ❤ by{" "}
        <a id="footer-logo" href="https://github.com/WhiteWolfDot">
          whitewolfdot
        </a>
      </div>
    </footer>
  );
}

export default Footer;
